@if (resolvedHtml(); as html) {
    <apcam-rich-text-renderer [html]="html" [class]="class()" />
}
